/**
 * PresentationFolderPreview React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2020 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

// application components
import PresentationFileView from "../presentation/kubus/PresentationFileView";
import PresentationAbstractView from "../presentation/kubus/PresentationAbstractView";
import PageSelection from "../base/PageSelection";
import ViewWidthScaling from "../base/ViewWidthScaling";

// application
import {selectObjectsForIds} from "../../redux/editing/selectors";
import {selectBaseStylesheet} from "../../redux/configuration/selectors";


/**
 * preview for presentation files
 *
 * @author Jens Gruschel
 */
class PresentationFolderPreview extends React.Component {

    state = {
        pageIndex: 0
    }

    render() {

        if (!this.props.visible) return null;

        const width = this.props.isTop ? 1080 : 300;
        const height = width * 2 * 16 / 9;

        if (this.props.isOverview) {
            return <div>
                {this.props.baseStylesheet && <style>
                    {this.props.baseStylesheet}
                </style>}
                <ViewWidthScaling width={width} height={height}>
                    <PresentationAbstractView
                        presentationFileOrFolder={this.props.object}
                        findReferencedObjects={this.props.findReferencedObjects}
                    />
                </ViewWidthScaling>
            </div>;
        }
        else {

            const objectFields = this.props.object.fields || {};
            const items = objectFields.items || [];
            const presentationFiles = this.props.findReferencedObjects(items);
            const pageCount = items.length;
            const pageIndex = Math.min(this.state.pageIndex, pageCount - 1);
    
            return <div>
                {this.props.baseStylesheet && <style>
                    {this.props.baseStylesheet}
                </style>}
                <ViewWidthScaling width={width} height={height}>
                    <PresentationFileView
                        presentationFile={presentationFiles[pageIndex]}
                        findReferencedObjects={this.props.findReferencedObjects}
                    />
                </ViewWidthScaling>
                {pageCount > 0 && <PageSelection
                    pageNumber={pageIndex + 1}
                    pageCount={pageCount}
                    onChange={(number) => this.setState({pageIndex: number - 1})}
                />}
            </div>;
        }
    }
}

PresentationFolderPreview.propTypes = {
    place: PropTypes.string.isRequired,
    fieldSet: PropTypes.object.isRequired,
    objectType: PropTypes.string,
    objectId: PropTypes.string,
    object: PropTypes.object,
    readOnly: PropTypes.bool,
    onObjectValueChange: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => {

    const isTop = props.place === "top";
    const visible = isTop ? props.fieldSet.id === "preview" : ["general", "content"].includes(props.fieldSet.id);
    const isOverview = props.fieldSet.id === "general";

    return {
        isTop: isTop,
        visible: visible,
        isOverview: isOverview,
        baseStylesheet: selectBaseStylesheet(state.configuration),
        findReferencedObjects: field => selectObjectsForIds(state.editing, field)
    }
}

export default connect(mapStateToProps)(PresentationFolderPreview);